import { render, staticRenderFns } from "./Challenge7.vue?vue&type=template&id=1c71e143&scoped=true&lang=pug&"
import script from "./Challenge7.vue?vue&type=script&lang=ts&"
export * from "./Challenge7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71e143",
  null
  
)

export default component.exports